import { Switch } from "@mui/material";
import { useMemo } from "react";

import { useDashboardLocationsQuery } from "@/features/admin/features/dashboards";
import { useAdminDashboard } from "@/features/admin/hooks";
import { countDashboardLocationsWithParameterLink } from "@/features/shared/widgets/observations-map/filter-stations-by-dashboard-locations";
import { useTranslation } from "@/lib/i18n";

import styles from "./observations-map-station-location-filter-panel.module.css";
import { useObservationsMapForm } from "./use-observations-map-form";

export function ObservationsMapStationLocationFilterPanel() {
  const { t } = useTranslation();
  const { showAllLocations, setShowAllLocations } = useObservationsMapForm();
  const dashboard = useAdminDashboard();
  const dashboardLocationsQuery = useDashboardLocationsQuery(dashboard?.id ?? "");

  const linkedLocationCount = useMemo(
    () => countDashboardLocationsWithParameterLink(dashboardLocationsQuery.data),
    [dashboardLocationsQuery.data],
  );

  if (!dashboard) return null;

  const limitToDashboardLocations = !showAllLocations;
  const limitLabel = t(
    "admin.widgets.fields.observations_map.marker_designs.station_location_filter.limit_to_dashboard_locations",
  );

  return (
    <div className={styles.card}>
      <div className={styles.cardContent}>
        <div className={styles.cardMain}>
          <span className={styles.label}>{limitLabel}</span>
          <p className={styles.helper}>
            {t(
              "admin.widgets.fields.observations_map.marker_designs.station_location_filter.linked_count",
              { count: linkedLocationCount },
            )}
          </p>
        </div>
        <Switch
          checked={limitToDashboardLocations}
          onChange={(_, checked) => setShowAllLocations(!checked)}
          color="primary"
          inputProps={{ "aria-label": limitLabel }}
        />
      </div>
    </div>
  );
}
